import BadGateway from "../../app/features/Badgetway"
const BadGatewayPage = () => {
    return <BadGateway />
}

export default BadGatewayPage